

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  </BrowserRouter>
);

// Drop the pre-React spinner from index.html now that there is something to
// look at. It was previously hidden on a flat 2s timer after `load`, which
// held a full-screen white overlay in front of an app that was already
// interactive. The timer survives as a fallback for a bundle that never runs.
// Nested rAF, not a single one: React 18 renders concurrently, so the first
// callback can run before the app has painted and would flash an empty #app.
// The inner one runs after that frame is on screen.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const loader = document.getElementById("loader");
    if (loader) loader.remove();
  });
});
